import FuseUtils from '@fuse/utils';
import FuseLoading from '@fuse/core/FuseLoading';
import { Navigate } from 'react-router-dom';
import settingsConfig from 'app/configs/settingsConfig';
import SignInConfig from '../main/sign-in/SignInConfig';
import SignUpConfig from '../main/sign-up/SignUpConfig';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import Error404Page from '../main/404/Error404Page';
import ManagersConfig from '../main/managers/ManagersConfig';
import HomeConfig from '../main/home/HomeConfig';
import DriversConfig from '../main/drivers/DriversConfig';
import TariffConfig from '../main/tariff/TariffConfig';
import TripsPageConfig from '../main/trips/AssignTripsPageConfig';
import CommunicationsConfig from '../main/communications/CommunicationsConfigs';

const routeConfigs = [
  ManagersConfig,
  SignOutConfig,
  SignInConfig,
  SignUpConfig,
  HomeConfig,
  DriversConfig,
  TariffConfig,
  TripsPageConfig,
  CommunicationsConfig,
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  {
    path: '/',
    element: <Navigate to="/dashboard" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Navigate to="404" />,
  },
];

export default routes;
